import React from "react";
import SkillSectionList from "./SkillSectionList";

import "./Toolkit.css";

function Toolkit() {
  return (
    <div className="toolkit__wrapper">
      <h1>My Toolkit</h1>
            <SkillSectionList />
    </div>
  );
}

export default Toolkit;
